/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { DialogInput } from '@gh/core-ui';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute } from '@gh/common-shared';

@Component({
  standalone: false,
  selector: 'gh-career-enquiries-dialog',
  templateUrl: 'career-enquiries-details.component.html',
  styleUrls: ['career-enquiries-details.component.scss'],
})
export class CareerEnquiriesDetailsComponent implements OnInit, DialogInput<any> {
  input: any;
  data: any;

  constructor(private dialogRef: MatDialogRef<any>) {

  }

  ngOnInit(): void {
    this.data = this.input.details;
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

export const careerEnquiriesDetailsDialogRoute = createDialogRoute({
  component: CareerEnquiriesDetailsComponent,
  config: {disableClose: true, width: '600px'},
});
